module.exports = __webpack_public_path__ + "static/media/sidebar-img2.d0bf183b.jpg";